
import { useAppSelector } from '../../data-services/store';
import {e_DemoType, ProductsRelDocs} from "../../interfaces";
import {getIsAuthenticated} from "../../../../../domain/hidden-data-provider";
import WishlistIcon from "../../../../../ui/svg/common/wishlist";
import GetDemoIcon from "../../../../../ui/svg/common/get-demo";
import PdfIcon from "../../../../../ui/svg/common/pdf";
import GetUpgradesIcon from "../../../../../ui/svg/common/get-upgrades";
import CRSDataDetails from "../../../../custom-pages/product-course/src-data-details/src-data-details";
import {sendGAEvent} from "../../../../../domain/marketing/gtm-provider";
import {AddToWishlist} from "../../../../wish-list/components/popups/add-to-wishlist/add-to-wishlist";
import InfoIcon from "../../../../../ui/svg/common/info";
interface IProductProps {
    product: ProductsRelDocs,
}

/**
 * the entry point
 */
const PRDHelpIcons= (props: IProductProps) => {
    const productsRelDocsInitialSelected = useAppSelector((store) => store.productsRelDocsInitialSelected);
    const isProductOptionsSelected = useAppSelector((store) => store.isProductOptionsSelected);
    const isUserLoggedIn = getIsAuthenticated();
    return (
        <div className="prd-help-icons w-full is-top-image-true">
            {
                <>


                    <div className="flex flex-wrap items-center justify-center w-full mt-5">
                        <dl className={`flex flex-wrap justify-start w-full items-center`}>
                            {
                                props.product.isWishlist &&
                                <dt className={`flex flex-row items-center justify-center text-sm no-underline pb-3 md:pb-0`} >
                                    {/*<WishlistIcon width="inherit" color="#ffffff" /> <span className="pl-1">Wish list</span>*/}
                                    <AddToWishlist classes="text-gray-700" skuid={props.product.isProductOptions && !isProductOptionsSelected ? props.product.skuParentSKUID : props.product.skuid }>
                                        <button type="button" className='flex flex-row items-center justify-center text-sm cursor-pointer pr-4'>
                                            <WishlistIcon width='21' color='#ffffff' />
                                            <span className='pl-2 text-white'>
                                                Wish List
                                                </span>
                                            </button>
                                    </AddToWishlist>
                                </dt>
                            }

                            {
                                props.product.numberOfLessons > 0 &&
                                <CRSDataDetails
                                    numberOfLessons={props.product.numberOfLessons}
                                    designType="numberOfLessons"
                                    classNameEx="numberOfLessonsClass"
                                    colorIcons="#ffffff"
                                />
                            }
                            {
                                props.product.courseDurationHours > 0 &&
                                <CRSDataDetails
                                    courseDurationHours={props.product.courseDurationHours}
                                    designType="courseDurationHours"
                                    classNameEx="courseDurationHoursClass"
                                    colorIcons="#ffffff"
                                />
                            }
                            {/*
                                props.product.numberOfPlugins > 0 &&
                                <CRSDataDetails
                                    numberOfPlugins={props.product.numberOfPlugins}
                                    designType="numberOfPlugins"
                                    classNameEx="numberOfPluginsClass"
                                    colorIcons="#ffffff"
                                />
                            */}
                            {
                                productsRelDocsInitialSelected.demoType === e_DemoType.FreeTrial &&
                                <dt className="pb-3 md:pb-0">
                                    <a className="flex flex-row text-white items-center justify-center text-sm no-underline pr-4"
                                       href={`/trial?trial=${props.product.documentUrlPath}`}
                                       title="Trial"
                                       onClick={(evt) => {
                                           sendGAEvent('Product Trial', props.product.documentName);
                                       }}>
                                    <GetDemoIcon width="22" color="#ffffff"/><span className="pl-1">Try Free</span>
                                    </a></dt>
                            }
                            {
                                productsRelDocsInitialSelected.demoType === e_DemoType.Demo &&
                                <dt className="pb-3 md:pb-0">
                                    <a className="flex flex-row text-white items-center justify-center text-sm no-underline pr-4"
                                       href={`/support/evaluate-and-demo-waves-products`}
                                       title="Demo"
                                       onClick={(evt) => {
                                           sendGAEvent('Product Demo with Mutes', props.product.documentName);
                                       }}>
                                        <InfoIcon width="22" color="#ffffff"/><span className="pl-1">Demo</span>
                                    </a></dt>
                            }

                            {
                                props.product.manualPDF &&
                                <dt className="pb-3 md:pb-0">
                                    <a className="flex flex-row text-white items-center justify-center text-sm no-underline pr-4"
                                       href={props.product.manualPDF}
                                       aria-label={`Open ${ props.product.documentName } User Guide PDF in a new tab`}
                                       target="_blank"
                                       rel="noreferrer"
                                       onClick={(evt) => {
                                           sendGAEvent('User Guide', props.product.documentName);
                                       }}>

                                    <PdfIcon width="20" color="#ffffff" /> <span className="pl-1">User Guide</span></a>
                                </dt>
                            }

                            {
                                props.product.upgrades &&
                                <dt className="pb-3 md:pb-0">
                                    <a className="flex  flex-wrap text-white items-center justify-center text-sm no-underline pr-4"
                                       href={`${isUserLoggedIn ? '/account/upgrades' : '/support/upgrades' } `}
                                       onClick={(evt) => {
                                           sendGAEvent('Upgrades', props.product.documentName);
                                       }}>
                                    <GetUpgradesIcon width="24" color="#ffffff" /> <span className="pl-1">Upgrades</span></a>
                                </dt>
                            }
                        </dl>
                    </div>

                </>
            }
        </div>
    )
};

export default PRDHelpIcons;